import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export const TRUE_MAX_TABLET_WIDTH = 1199;
export const MAX_MOBILE_WIDTH = 809;

@Injectable({ providedIn: 'root' })
export class ScreenService {
  static TRUE_TABLET_WIDTH = TRUE_MAX_TABLET_WIDTH;
  private _isMobile = new BehaviorSubject<boolean>(false);
  public isMobile$ = this._isMobile.pipe(distinctUntilChanged());
  private _isTabletOrSmaller = new BehaviorSubject<boolean>(false);
  public isTabletOrSmaller$ = this._isTabletOrSmaller.pipe(distinctUntilChanged());
  private _mobileNavScrollLocked = new BehaviorSubject<boolean>(false);
  public mobileNavScrollLocked$ = this._mobileNavScrollLocked.pipe(distinctUntilChanged());
  private _width = new BehaviorSubject<number>(0);
  public width$ = this._width.asObservable();

  private _showOverlay = new BehaviorSubject<boolean>(false);
  public showOverlay$ = this._showOverlay as Observable<boolean>;

  private _disableScroll = new BehaviorSubject<boolean>(false);
  public disableScroll$ = this._disableScroll as Observable<boolean>;

  constructor() {}

  setWidth(w: number) {
    this._width.next(w);
  }

  setIsTabletOrSmaller(x: boolean) {
    this._isTabletOrSmaller.next(x);
  }

  setMobileNavScrollLocked(isMobileNavScrollLocked: boolean) {
    this._mobileNavScrollLocked.next(isMobileNavScrollLocked);
  }

  hideOverlay(): void {
    this._showOverlay.next(false);
  }

  showOverlay(): void {
    this._showOverlay.next(true);
  }

  disableScroll(): void {
    this._disableScroll.next(true);
  }

  enableScroll(): void {
    this._disableScroll.next(false);
  }

  setIsMobile(x: boolean) {
    this._isMobile.next(x);
  }
}
